import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const LANGUAGES = [
  { value: 'ru', label: 'RU' },
  { value: 'kz', label: 'KZ' },
  { value: 'en', label: 'EN' }
];

export const PromotionDescriptionEditor = ({ values, errors = {}, onChange }) => (
  <Box sx={{ width: '100%', minWidth: 0 }}>
    <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: 'black' }}>
      Полное описание акции
    </Typography>

    <Grid container spacing={3}>
      {LANGUAGES.map((language) => {
        const error = errors?.[language.value];

        return (
          <Grid item xs={12} key={language.value} sx={{ minWidth: 0, maxWidth: '100%' }}>
            <Paper
              elevation={1}
              sx={{
                p: 2,
                borderRadius: 2,
                minWidth: 0,
                maxWidth: '100%',
                overflow: 'hidden',
                border: error ? '2px solid #f44336' : 'none'
              }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 500, color: 'text.primary' }}>
                Полное описание ({language.label})
              </Typography>

              <Editor
                editorState={values?.[language.value] || EditorState.createEmpty()}
                onEditorStateChange={(editorState) => onChange(language.value, editorState)}
                placeholder={`Описание ${language.value}`}
                toolbar={{
                  options: [
                    'inline',
                    'blockType',
                    'fontSize',
                    'fontFamily',
                    'list',
                    'textAlign',
                    'link',
                    'image',
                    'history'
                  ],
                  inline: { inDropdown: true },
                  list: { inDropdown: true },
                  textAlign: { inDropdown: true },
                  link: { inDropdown: true },
                  history: { inDropdown: true }
                }}
                wrapperStyle={{
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                  boxSizing: 'border-box',
                  border: error ? '1px solid #f44336' : '1px solid #e0e0e0',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
                toolbarStyle={{ width: '100%', boxSizing: 'border-box', flexWrap: 'wrap' }}
                editorStyle={{
                  minHeight: '250px',
                  padding: '16px',
                  fontSize: '14px',
                  width: '100%',
                  maxWidth: '100%',
                  boxSizing: 'border-box',
                  overflowWrap: 'anywhere',
                  wordBreak: 'break-word',
                  whiteSpace: 'pre-wrap'
                }}
              />

              {error && (
                <Box color="error.main" fontSize="1rem" textAlign="center" mt={1}>
                  {error}
                </Box>
              )}
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  </Box>
);

PromotionDescriptionEditor.propTypes = {
  values: PropTypes.shape({
    ru: PropTypes.object,
    kz: PropTypes.object,
    en: PropTypes.object
  }).isRequired,
  errors: PropTypes.shape({
    ru: PropTypes.node,
    kz: PropTypes.node,
    en: PropTypes.node
  }),
  onChange: PropTypes.func.isRequired
};
